import React, { FC } from 'react'

import styles from './tabList.module.scss'

export const TabList: FC = ({ children }) => (
  <nav className={styles['tab-lists']}>{children}</nav>
)
